import React, { PropsWithChildren } from "react";

import { ThemeProviderWrapper } from "@/context/Theme";
import { CssBaseline } from "@mui/material";

interface ThemeContainerProps {
  children: React.ReactNode;
}

const ThemeContainer = ({
  children,
}: PropsWithChildren<ThemeContainerProps>): JSX.Element | null => {
  return (
    <ThemeProviderWrapper>
      <CssBaseline />
      {children}
    </ThemeProviderWrapper>
  );
};

export default ThemeContainer;
